import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
export default EmberDataBaseModel.extend({
  prefectureIsoCode: attr('string'),
  kanjiName: attr('string'),
  kanaName: attr('string'),
  romajiName: attr('string'),
  agrexCode: attr('string')
}).reopenClass({
  _modelNameForMigration: 'jp-prefecture'
});